// @flow

import { isMobile } from './device'

export const IFRAME_SUBSCRIBER_ID = 'subscriberId'
export const IFRAME_CUSTOMER_ID = 'customer_id'
export const IFRAME_IS_MOBILE = 'is_mobile'
export const IFRAME_ORIGIN = 'origin'
export const IFRAME_PARENT_URL = 'parent_url'
export const WIZARD_INTEGRATION_ID = 'wizard_integration_id'
export const IS_ENABLED_AB_TEST = 'is_enabled_ab_test'
export const IS_ENABLED_POSTHOG = 'is_enabled_posthog'
export const ALIGN_BOT_MOBILE = 'align_bot_mobile'
export const ALIGN_BOT_DESKTOP = 'align_bot_desktop'

export function buildIframeQueryParams (customerId: string, subscriberId: string, params: Object = {}): Object {
  return {
    ...params,
    [IFRAME_CUSTOMER_ID]: customerId,
    [IFRAME_SUBSCRIBER_ID]: subscriberId,
    [IFRAME_ORIGIN]: window.location.origin,
    [IFRAME_PARENT_URL]: window.location.href,
    [IFRAME_IS_MOBILE]: isMobile().toString()
  }
}
